module.exports = __webpack_public_path__ + "static/media/Vue-SDB_03-Roche-Lin-2.b185e46b.jpg";